var _module_exports = "<span>This project was refunded.</span>\n";;
var path = 'views/flashes/task_refunded.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;